/**
 * The call's look (ITP-E-185-02, D-11), one source for Meet's picture-in-picture and the compact call view. The colours
 * and sizes are `shared/styles/_call-tokens.scss`'s, here for the PiP's CSS string — a separate document Angular's
 * stylesheets never reach; the compact call view's spec holds the two equal.
 */
export const CALL_COLORS = {
  stage: '#161A1D',
  avatarStage: '#252738',
  avatar: 'purple',
  button: '#2C333A',
  buttonHover: '#3A434C',
  name: '#2c333ac2',
  danger: '#DE3D3D',
  active: '#175CFF'
} as const;

export const CALL_SIZES = {
  radius: '5px',
  gap: '10px',
  buttonSize: '45px',
  iconSize: '1.2rem'
} as const;

/**
 * The icons, as Meet's picture-in-picture draws them (meet-sessionv2's PiP footer and its toolbar): Font Awesome regular,
 * the raised hand light, the ⋯ and the settings gear solid as Meet's are.
 */
export const CALL_ICONS = {
  microphone: 'fa-regular fa-microphone',
  microphoneOff: 'fa-regular fa-microphone-slash',
  camera: 'fa-regular fa-video',
  cameraOff: 'fa-regular fa-video-slash',
  raiseHand: 'fa-light fa-hand',
  share: 'fa-regular fa-arrow-up-from-square',
  options: 'fa-solid fa-ellipsis-stroke',
  leave: 'fa-regular fa-right-to-bracket',
  hangUp: 'fa-regular fa-phone-hangup',
  participants: 'fa-regular fa-user-group',
  /** Add by phone (ITP-E-198-01). */
  addPhone: 'fa-regular fa-phone-plus',
  devices: 'fa-solid fa-gear',
  record: 'fa-regular fa-record-vinyl',
  stopRecording: 'fa-regular fa-circle-stop',
  openInMeet: 'fa-regular fa-arrow-up-right-from-square',
  expand: 'fa-solid fa-up-right-and-down-left-from-center',
  previous: 'fa-regular fa-circle-arrow-left',
  next: 'fa-regular fa-circle-arrow-right'
} as const;
